import React, { FC } from 'react'
import { Advertising } from './Advertising'
import { YandexAdvertisingSliceId } from './YandexAdvertisingSliceId'
import { adsenseConfig } from './adsenseConfig'

export const WebcamLandingAdvertising: FC = () => {
  return (
    <Advertising
      className="mx-auto h-[90px]"
      yandex={{
        sliceId: YandexAdvertisingSliceId.Webcam,
      }}
      adsense={{
        slot: adsenseConfig.slots.landing,
        channel: adsenseConfig.channels.cam,
      }}
    />
  )
}
